import De, { useState as A, useRef as oe, useEffect as F } from "react";
var se = { exports: {} }, I = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pe;
function Cr() {
  if (Pe)
    return I;
  Pe = 1;
  var r = De, i = Symbol.for("react.element"), a = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, l = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(m, p, _) {
    var b, E = {}, w = null, S = null;
    _ !== void 0 && (w = "" + _), p.key !== void 0 && (w = "" + p.key), p.ref !== void 0 && (S = p.ref);
    for (b in p)
      o.call(p, b) && !s.hasOwnProperty(b) && (E[b] = p[b]);
    if (m && m.defaultProps)
      for (b in p = m.defaultProps, p)
        E[b] === void 0 && (E[b] = p[b]);
    return { $$typeof: i, type: m, key: w, ref: S, props: E, _owner: l.current };
  }
  return I.Fragment = a, I.jsx = d, I.jsxs = d, I;
}
var V = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Le;
function Er() {
  return Le || (Le = 1, process.env.NODE_ENV !== "production" && function() {
    var r = De, i = Symbol.for("react.element"), a = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), m = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), _ = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), B = Symbol.iterator, Ve = "@@iterator";
    function We(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = B && e[B] || e[Ve];
      return typeof t == "function" ? t : null;
    }
    var L = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(e) {
      {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), u = 1; u < t; u++)
          n[u - 1] = arguments[u];
        Be("error", e, n);
      }
    }
    function Be(e, t, n) {
      {
        var u = L.ReactDebugCurrentFrame, h = u.getStackAddendum();
        h !== "" && (t += "%s", n = n.concat([h]));
        var g = n.map(function(v) {
          return String(v);
        });
        g.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, g);
      }
    }
    var Ue = !1, Ye = !1, He = !1, Ze = !1, qe = !1, ue;
    ue = Symbol.for("react.module.reference");
    function Ge(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === o || e === s || qe || e === l || e === _ || e === b || Ze || e === S || Ue || Ye || He || typeof e == "object" && e !== null && (e.$$typeof === w || e.$$typeof === E || e.$$typeof === d || e.$$typeof === m || e.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ue || e.getModuleId !== void 0));
    }
    function Je(e, t, n) {
      var u = e.displayName;
      if (u)
        return u;
      var h = t.displayName || t.name || "";
      return h !== "" ? n + "(" + h + ")" : n;
    }
    function le(e) {
      return e.displayName || "Context";
    }
    function j(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case o:
          return "Fragment";
        case a:
          return "Portal";
        case s:
          return "Profiler";
        case l:
          return "StrictMode";
        case _:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case m:
            var t = e;
            return le(t) + ".Consumer";
          case d:
            var n = e;
            return le(n._context) + ".Provider";
          case p:
            return Je(e, e.render, "ForwardRef");
          case E:
            var u = e.displayName || null;
            return u !== null ? u : j(e.type) || "Memo";
          case w: {
            var h = e, g = h._payload, v = h._init;
            try {
              return j(v(g));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var k = Object.assign, D = 0, ce, fe, de, ve, pe, he, me;
    function ge() {
    }
    ge.__reactDisabledLog = !0;
    function ze() {
      {
        if (D === 0) {
          ce = console.log, fe = console.info, de = console.warn, ve = console.error, pe = console.group, he = console.groupCollapsed, me = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ge,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        D++;
      }
    }
    function Ke() {
      {
        if (D--, D === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: k({}, e, {
              value: ce
            }),
            info: k({}, e, {
              value: fe
            }),
            warn: k({}, e, {
              value: de
            }),
            error: k({}, e, {
              value: ve
            }),
            group: k({}, e, {
              value: pe
            }),
            groupCollapsed: k({}, e, {
              value: he
            }),
            groupEnd: k({}, e, {
              value: me
            })
          });
        }
        D < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var J = L.ReactCurrentDispatcher, z;
    function U(e, t, n) {
      {
        if (z === void 0)
          try {
            throw Error();
          } catch (h) {
            var u = h.stack.trim().match(/\n( *(at )?)/);
            z = u && u[1] || "";
          }
        return `
` + z + e;
      }
    }
    var K = !1, Y;
    {
      var Xe = typeof WeakMap == "function" ? WeakMap : Map;
      Y = new Xe();
    }
    function be(e, t) {
      if (!e || K)
        return "";
      {
        var n = Y.get(e);
        if (n !== void 0)
          return n;
      }
      var u;
      K = !0;
      var h = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var g;
      g = J.current, J.current = null, ze();
      try {
        if (t) {
          var v = function() {
            throw Error();
          };
          if (Object.defineProperty(v.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(v, []);
            } catch (O) {
              u = O;
            }
            Reflect.construct(e, [], v);
          } else {
            try {
              v.call();
            } catch (O) {
              u = O;
            }
            e.call(v.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (O) {
            u = O;
          }
          e();
        }
      } catch (O) {
        if (O && u && typeof O.stack == "string") {
          for (var f = O.stack.split(`
`), R = u.stack.split(`
`), y = f.length - 1, C = R.length - 1; y >= 1 && C >= 0 && f[y] !== R[C]; )
            C--;
          for (; y >= 1 && C >= 0; y--, C--)
            if (f[y] !== R[C]) {
              if (y !== 1 || C !== 1)
                do
                  if (y--, C--, C < 0 || f[y] !== R[C]) {
                    var T = `
` + f[y].replace(" at new ", " at ");
                    return e.displayName && T.includes("<anonymous>") && (T = T.replace("<anonymous>", e.displayName)), typeof e == "function" && Y.set(e, T), T;
                  }
                while (y >= 1 && C >= 0);
              break;
            }
        }
      } finally {
        K = !1, J.current = g, Ke(), Error.prepareStackTrace = h;
      }
      var N = e ? e.displayName || e.name : "", Fe = N ? U(N) : "";
      return typeof e == "function" && Y.set(e, Fe), Fe;
    }
    function Qe(e, t, n) {
      return be(e, !1);
    }
    function er(e) {
      var t = e.prototype;
      return !!(t && t.isReactComponent);
    }
    function H(e, t, n) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return be(e, er(e));
      if (typeof e == "string")
        return U(e);
      switch (e) {
        case _:
          return U("Suspense");
        case b:
          return U("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case p:
            return Qe(e.render);
          case E:
            return H(e.type, t, n);
          case w: {
            var u = e, h = u._payload, g = u._init;
            try {
              return H(g(h), t, n);
            } catch {
            }
          }
        }
      return "";
    }
    var Z = Object.prototype.hasOwnProperty, _e = {}, ye = L.ReactDebugCurrentFrame;
    function q(e) {
      if (e) {
        var t = e._owner, n = H(e.type, e._source, t ? t.type : null);
        ye.setExtraStackFrame(n);
      } else
        ye.setExtraStackFrame(null);
    }
    function rr(e, t, n, u, h) {
      {
        var g = Function.call.bind(Z);
        for (var v in e)
          if (g(e, v)) {
            var f = void 0;
            try {
              if (typeof e[v] != "function") {
                var R = Error((u || "React class") + ": " + n + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw R.name = "Invariant Violation", R;
              }
              f = e[v](t, v, u, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (y) {
              f = y;
            }
            f && !(f instanceof Error) && (q(h), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", u || "React class", n, v, typeof f), q(null)), f instanceof Error && !(f.message in _e) && (_e[f.message] = !0, q(h), x("Failed %s type: %s", n, f.message), q(null));
          }
      }
    }
    var tr = Array.isArray;
    function X(e) {
      return tr(e);
    }
    function nr(e) {
      {
        var t = typeof Symbol == "function" && Symbol.toStringTag, n = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return n;
      }
    }
    function ir(e) {
      try {
        return Ce(e), !1;
      } catch {
        return !0;
      }
    }
    function Ce(e) {
      return "" + e;
    }
    function Ee(e) {
      if (ir(e))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", nr(e)), Ce(e);
    }
    var M = L.ReactCurrentOwner, ar = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xe, Re, Q;
    Q = {};
    function or(e) {
      if (Z.call(e, "ref")) {
        var t = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function sr(e) {
      if (Z.call(e, "key")) {
        var t = Object.getOwnPropertyDescriptor(e, "key").get;
        if (t && t.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function ur(e, t) {
      if (typeof e.ref == "string" && M.current && t && M.current.stateNode !== t) {
        var n = j(M.current.type);
        Q[n] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(M.current.type), e.ref), Q[n] = !0);
      }
    }
    function lr(e, t) {
      {
        var n = function() {
          xe || (xe = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: n,
          configurable: !0
        });
      }
    }
    function cr(e, t) {
      {
        var n = function() {
          Re || (Re = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
        };
        n.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: n,
          configurable: !0
        });
      }
    }
    var fr = function(e, t, n, u, h, g, v) {
      var f = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: i,
        // Built-in properties that belong on the element
        type: e,
        key: t,
        ref: n,
        props: v,
        // Record the component responsible for creating this element.
        _owner: g
      };
      return f._store = {}, Object.defineProperty(f._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(f, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: u
      }), Object.defineProperty(f, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.freeze && (Object.freeze(f.props), Object.freeze(f)), f;
    };
    function dr(e, t, n, u, h) {
      {
        var g, v = {}, f = null, R = null;
        n !== void 0 && (Ee(n), f = "" + n), sr(t) && (Ee(t.key), f = "" + t.key), or(t) && (R = t.ref, ur(t, h));
        for (g in t)
          Z.call(t, g) && !ar.hasOwnProperty(g) && (v[g] = t[g]);
        if (e && e.defaultProps) {
          var y = e.defaultProps;
          for (g in y)
            v[g] === void 0 && (v[g] = y[g]);
        }
        if (f || R) {
          var C = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          f && lr(v, C), R && cr(v, C);
        }
        return fr(e, f, R, h, u, M.current, v);
      }
    }
    var ee = L.ReactCurrentOwner, Te = L.ReactDebugCurrentFrame;
    function $(e) {
      if (e) {
        var t = e._owner, n = H(e.type, e._source, t ? t.type : null);
        Te.setExtraStackFrame(n);
      } else
        Te.setExtraStackFrame(null);
    }
    var re;
    re = !1;
    function te(e) {
      return typeof e == "object" && e !== null && e.$$typeof === i;
    }
    function we() {
      {
        if (ee.current) {
          var e = j(ee.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function vr(e) {
      {
        if (e !== void 0) {
          var t = e.fileName.replace(/^.*[\\\/]/, ""), n = e.lineNumber;
          return `

Check your code at ` + t + ":" + n + ".";
        }
        return "";
      }
    }
    var Se = {};
    function pr(e) {
      {
        var t = we();
        if (!t) {
          var n = typeof e == "string" ? e : e.displayName || e.name;
          n && (t = `

Check the top-level render call using <` + n + ">.");
        }
        return t;
      }
    }
    function je(e, t) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var n = pr(t);
        if (Se[n])
          return;
        Se[n] = !0;
        var u = "";
        e && e._owner && e._owner !== ee.current && (u = " It was passed a child from " + j(e._owner.type) + "."), $(e), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, u), $(null);
      }
    }
    function Oe(e, t) {
      {
        if (typeof e != "object")
          return;
        if (X(e))
          for (var n = 0; n < e.length; n++) {
            var u = e[n];
            te(u) && je(u, t);
          }
        else if (te(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var h = We(e);
          if (typeof h == "function" && h !== e.entries)
            for (var g = h.call(e), v; !(v = g.next()).done; )
              te(v.value) && je(v.value, t);
        }
      }
    }
    function hr(e) {
      {
        var t = e.type;
        if (t == null || typeof t == "string")
          return;
        var n;
        if (typeof t == "function")
          n = t.propTypes;
        else if (typeof t == "object" && (t.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        t.$$typeof === E))
          n = t.propTypes;
        else
          return;
        if (n) {
          var u = j(t);
          rr(n, e.props, "prop", u, e);
        } else if (t.PropTypes !== void 0 && !re) {
          re = !0;
          var h = j(t);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", h || "Unknown");
        }
        typeof t.getDefaultProps == "function" && !t.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function mr(e) {
      {
        for (var t = Object.keys(e.props), n = 0; n < t.length; n++) {
          var u = t[n];
          if (u !== "children" && u !== "key") {
            $(e), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", u), $(null);
            break;
          }
        }
        e.ref !== null && ($(e), x("Invalid attribute `ref` supplied to `React.Fragment`."), $(null));
      }
    }
    function ke(e, t, n, u, h, g) {
      {
        var v = Ge(e);
        if (!v) {
          var f = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (f += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var R = vr(h);
          R ? f += R : f += we();
          var y;
          e === null ? y = "null" : X(e) ? y = "array" : e !== void 0 && e.$$typeof === i ? (y = "<" + (j(e.type) || "Unknown") + " />", f = " Did you accidentally export a JSX literal instead of a component?") : y = typeof e, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", y, f);
        }
        var C = dr(e, t, n, h, g);
        if (C == null)
          return C;
        if (v) {
          var T = t.children;
          if (T !== void 0)
            if (u)
              if (X(T)) {
                for (var N = 0; N < T.length; N++)
                  Oe(T[N], e);
                Object.freeze && Object.freeze(T);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Oe(T, e);
        }
        return e === o ? mr(C) : hr(C), C;
      }
    }
    function gr(e, t, n) {
      return ke(e, t, n, !0);
    }
    function br(e, t, n) {
      return ke(e, t, n, !1);
    }
    var _r = br, yr = gr;
    V.Fragment = o, V.jsx = _r, V.jsxs = yr;
  }()), V;
}
process.env.NODE_ENV === "production" ? se.exports = Cr() : se.exports = Er();
var c = se.exports;
const xr = {
  undo: "يعود",
  undoing: "العودة",
  operationWasUndone: "تمت إرجاع العملية",
  errorInOperation: "خطأ في التشغيل"
}, Rr = {
  undo: "undo",
  undoing: "undoing",
  operationWasUndone: "The operation was undone",
  errorInOperation: "error in operation"
}, Tr = {
  undo: "برگرداندن",
  undoing: "در حال بازگردانی",
  operationWasUndone: "عملیات بازگردانده شد",
  errorInOperation: "خطا در انجام عملیات"
}, wr = (r) => {
  const i = r.split("-"), a = {
    top: "unset",
    bottom: "unset",
    right: "unset",
    left: "unset"
  };
  return i[0] === "top" ? a.top = 10 : a.bottom = 10, i[1] === "right" ? a.right = 10 : a.left = 10, a;
}, Sr = (r, i) => r ? i !== "unset" ? "animate__bounceInLeft" : "animate__bounceInRight" : i !== "unset" ? "animate__bounceOutLeft" : "animate__bounceOutRight", ne = (r) => Object.fromEntries(Object.entries(r).filter(([i, a]) => a !== void 0)), jr = () => {
  let r = "xxxxxxxx-xxxx-Mxxx-Nxxx-x".replace(/[xMN]/g, (i) => {
    let a;
    return i === "M" ? a = Math.floor(1 + Math.random() * 5) : i === "N" ? a = Math.floor(8 + Math.random() * 4) : a = Math.floor(Math.random() * 16), a.toString(16);
  });
  return r += Date.now().toString(16), r;
}, ie = (r) => {
  switch (r) {
    case "en":
      return Rr;
    case "ar":
      return xr;
    default:
      return Tr;
  }
};
var Or = /* @__PURE__ */ function() {
  function r(a) {
    this.subscriber = a;
  }
  var i = r.prototype;
  return i.remove = function() {
    this.subscriber && (this.subscriber.removeSubscription(this), this.subscriber = null);
  }, r;
}(), kr = Or;
function Fr(r, i) {
  r.prototype = Object.create(i.prototype), r.prototype.constructor = r, r.__proto__ = i;
}
var Pr = kr, Lr = /* @__PURE__ */ function(r) {
  Fr(i, r);
  function i(a, o, l) {
    var s;
    return s = r.call(this, a) || this, s.listener = o, s.context = l, s;
  }
  return i;
}(Pr), Me = Lr, $r = process.env.NODE_ENV !== "production" ? function(r) {
  if (r === void 0)
    throw new Error("invariant(...): Second argument must be a string.");
} : function(r) {
};
function Nr(r, i) {
  for (var a = arguments.length, o = new Array(a > 2 ? a - 2 : 0), l = 2; l < a; l++)
    o[l - 2] = arguments[l];
  if ($r(i), !r) {
    var s;
    if (i === void 0)
      s = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var d = 0;
      s = new Error(i.replace(/%s/g, function() {
        return String(o[d++]);
      })), s.name = "Invariant Violation";
    }
    throw s.framesToPop = 1, s;
  }
}
var Ie = Nr, $e = Ie, Ar = /* @__PURE__ */ function() {
  function r() {
    this._subscriptionsForType = {}, this._currentSubscription = null;
  }
  var i = r.prototype;
  return i.addSubscription = function(o, l) {
    l.subscriber !== this && (process.env.NODE_ENV !== "production" ? $e(!1, "The subscriber of the subscription is incorrectly set.") : $e(!1)), this._subscriptionsForType[o] || (this._subscriptionsForType[o] = []);
    var s = this._subscriptionsForType[o].length;
    return this._subscriptionsForType[o].push(l), l.eventType = o, l.key = s, l;
  }, i.removeAllSubscriptions = function(o) {
    o === void 0 ? this._subscriptionsForType = {} : delete this._subscriptionsForType[o];
  }, i.removeSubscription = function(o) {
    var l = o.eventType, s = o.key, d = this._subscriptionsForType[l];
    d && delete d[s];
  }, i.getSubscriptionsForType = function(o) {
    return this._subscriptionsForType[o];
  }, r;
}(), Dr = Ar;
function G(r) {
  return function() {
    return r;
  };
}
var P = function() {
};
P.thatReturns = G;
P.thatReturnsFalse = G(!1);
P.thatReturnsTrue = G(!0);
P.thatReturnsNull = G(null);
P.thatReturnsThis = function() {
  return this;
};
P.thatReturnsArgument = function(r) {
  return r;
};
var Mr = P, Ir = Me, Vr = Dr, Ne = Ie, Wr = Mr, Br = /* @__PURE__ */ function() {
  function r() {
    this._subscriber = new Vr(), this._currentSubscription = null;
  }
  var i = r.prototype;
  return i.addListener = function(o, l, s) {
    return this._subscriber.addSubscription(o, new Ir(this._subscriber, l, s));
  }, i.once = function(o, l, s) {
    var d = this;
    return this.addListener(o, function() {
      d.removeCurrentListener(), l.apply(s, arguments);
    });
  }, i.removeAllListeners = function(o) {
    this._subscriber.removeAllSubscriptions(o);
  }, i.removeCurrentListener = function() {
    this._currentSubscription || (process.env.NODE_ENV !== "production" ? Ne(!1, "Not in an emitting cycle; there is no current subscription") : Ne(!1)), this._subscriber.removeSubscription(this._currentSubscription);
  }, i.listeners = function(o) {
    var l = this._subscriber.getSubscriptionsForType(o);
    return l ? l.filter(Wr.thatReturnsTrue).map(function(s) {
      return s.listener;
    }) : [];
  }, i.emit = function(o) {
    var l = this._subscriber.getSubscriptionsForType(o);
    if (l) {
      for (var s = Object.keys(l), d = 0; d < s.length; d++) {
        var m = s[d], p = l[m];
        p && (this._currentSubscription = p, this.__emitToSubscription.apply(this, [p].concat(Array.prototype.slice.call(arguments))));
      }
      this._currentSubscription = null;
    }
  }, i.__emitToSubscription = function(o, l) {
    var s = Array.prototype.slice.call(arguments, 2);
    o.listener.apply(o.context, s);
  }, r;
}(), Ur = Br, Yr = {
  EventEmitter: Ur,
  EmitterSubscription: Me
}, Hr = Yr;
const W = new Hr.EventEmitter(), Zr = ({ className: r, onClick: i, theme: a }) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    onClick: i,
    style: { marginTop: "1px" },
    children: [
      /* @__PURE__ */ c.jsx(
        "path",
        {
          className: `${a === "dark" ? "fill-red-dark" : "fill-red-light"}`,
          opacity: "0.8",
          d: "M21.76 15.92L15.36 4.4C14.5 2.85 13.31 2 12 2C10.69 2 9.49998 2.85 8.63998 4.4L2.23998 15.92C1.42998 17.39 1.33998 18.8 1.98998 19.91C2.63998 21.02 3.91998 21.63 5.59998 21.63H18.4C20.08 21.63 21.36 21.02 22.01 19.91C22.66 18.8 22.57 17.38 21.76 15.92Z"
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          className: "fill_gray_color",
          d: "M12 14.75C11.59 14.75 11.25 14.41 11.25 14V9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9V14C12.75 14.41 12.41 14.75 12 14.75Z"
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          className: "fill_gray_color",
          d: "M12 18.0005C11.94 18.0005 11.87 17.9905 11.8 17.9805C11.74 17.9705 11.68 17.9505 11.62 17.9205C11.56 17.9005 11.5 17.8705 11.44 17.8305C11.39 17.7905 11.34 17.7505 11.29 17.7105C11.11 17.5205 11 17.2605 11 17.0005C11 16.7405 11.11 16.4805 11.29 16.2905C11.34 16.2505 11.39 16.2105 11.44 16.1705C11.5 16.1305 11.56 16.1005 11.62 16.0805C11.68 16.0505 11.74 16.0305 11.8 16.0205C11.93 15.9905 12.07 15.9905 12.19 16.0205C12.26 16.0305 12.32 16.0505 12.38 16.0805C12.44 16.1005 12.5 16.1305 12.56 16.1705C12.61 16.2105 12.66 16.2505 12.71 16.2905C12.89 16.4805 13 16.7405 13 17.0005C13 17.2605 12.89 17.5205 12.71 17.7105C12.66 17.7505 12.61 17.7905 12.56 17.8305C12.5 17.8705 12.44 17.9005 12.38 17.9205C12.32 17.9505 12.26 17.9705 12.19 17.9805C12.13 17.9905 12.06 18.0005 12 18.0005Z"
        }
      )
    ]
  }
), qr = ({ className: r, onClick: i, theme: a }) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    onClick: i,
    style: { marginTop: "1px" },
    children: [
      /* @__PURE__ */ c.jsx(
        "path",
        {
          className: `${a === "dark" ? "fill-lime-dark" : "fill-lime-light"}`,
          opacity: "0.8",
          d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          className: "fill_gray_color",
          d: "M10.5799 15.5796C10.3799 15.5796 10.1899 15.4996 10.0499 15.3596L7.21994 12.5296C6.92994 12.2396 6.92994 11.7596 7.21994 11.4696C7.50994 11.1796 7.98994 11.1796 8.27994 11.4696L10.5799 13.7696L15.7199 8.62961C16.0099 8.33961 16.4899 8.33961 16.7799 8.62961C17.0699 8.91961 17.0699 9.39961 16.7799 9.68961L11.1099 15.3596C10.9699 15.4996 10.7799 15.5796 10.5799 15.5796Z"
        }
      )
    ]
  }
), Gr = ({ className: r, onClick: i, theme: a }) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    onClick: i,
    style: { marginTop: "1px" },
    children: [
      /* @__PURE__ */ c.jsx(
        "path",
        {
          className: `${a === "dark" ? "fill-orange-dark" : "fill-orange-light"}`,
          opacity: "0.8",
          d: "M16.34 2H7.67C4.28 2 2 4.38 2 7.92V16.09C2 19.62 4.28 22 7.67 22H16.34C19.73 22 22 19.62 22 16.09V7.92C22 4.38 19.73 2 16.34 2Z"
        }
      ),
      /* @__PURE__ */ c.jsx(
        "path",
        {
          className: "fill_gray_color",
          d: "M11 15.7825V11.3625C11 11.1305 11.0922 10.9079 11.2563 10.7438C11.4204 10.5797 11.6429 10.4875 11.875 10.4875C12.1071 10.4875 12.3296 10.5797 12.4937 10.7438C12.6578 10.9079 12.75 11.1305 12.75 11.3625V15.7825C12.75 16.0146 12.6578 16.2372 12.4937 16.4013C12.3296 16.5654 12.1071 16.6575 11.875 16.6575C11.6429 16.6575 11.4204 16.5654 11.2563 16.4013C11.0922 16.2372 11 16.0146 11 15.7825V15.7825ZM11.005 8.18955C11.0044 8.01539 11.0556 7.84499 11.1522 7.70002C11.2487 7.55505 11.3861 7.44206 11.547 7.37542C11.7079 7.30877 11.885 7.29149 12.0558 7.32576C12.2265 7.36004 12.3832 7.44432 12.506 7.56789C12.6287 7.69147 12.7119 7.84875 12.745 8.01973C12.7781 8.19072 12.7596 8.36769 12.6918 8.52813C12.6241 8.68858 12.5102 8.82525 12.3645 8.92077C12.2189 9.01628 12.0482 9.06633 11.874 9.06455C11.6432 9.06218 11.4227 8.96905 11.26 8.80529C11.0974 8.64154 11.0058 8.42034 11.005 8.18955Z"
        }
      )
    ]
  }
), Jr = () => /* @__PURE__ */ c.jsx("div", { className: "promise-loader" }), zr = ({ type: r, theme: i }) => {
  let a = /* @__PURE__ */ c.jsx(c.Fragment, {});
  return r === "success" ? a = /* @__PURE__ */ c.jsx(qr, { theme: i }) : r === "warning" ? a = /* @__PURE__ */ c.jsx(Gr, { theme: i }) : r === "error" ? a = /* @__PURE__ */ c.jsx(Zr, { theme: i }) : r === "promise" && (a = /* @__PURE__ */ c.jsx(Jr, {})), /* @__PURE__ */ c.jsx("div", { style: { flex: "none" }, children: a });
}, Kr = ({ className: r, onClick: i, theme: a }) => /* @__PURE__ */ c.jsxs("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: r, onClick: i, children: [
  /* @__PURE__ */ c.jsx(
    "path",
    {
      className: `${a === "dark" ? "toast_undo-fill-dark" : "toast_undo-fill-light"}`,
      d: "M11.3477 14.2949H5.34766C5.04016 14.2949 4.78516 14.0399 4.78516 13.7324C4.78516 13.4249 5.04016 13.1699 5.34766 13.1699H11.3477C13.1027 13.1699 14.5352 11.7374 14.5352 9.98242C14.5352 8.22742 13.1027 6.79492 11.3477 6.79492H3.09766C2.79016 6.79492 2.53516 6.53992 2.53516 6.23242C2.53516 5.92492 2.79016 5.66992 3.09766 5.66992H11.3477C13.7252 5.66992 15.6602 7.60492 15.6602 9.98242C15.6602 12.3599 13.7252 14.2949 11.3477 14.2949Z"
    }
  ),
  /* @__PURE__ */ c.jsx(
    "path",
    {
      className: `${a === "dark" ? "toast_undo-fill-dark" : "toast_undo-fill-light"}`,
      d: "M4.82242 8.67016C4.67992 8.67016 4.53742 8.61766 4.42492 8.50516L2.50492 6.58516C2.28742 6.36766 2.28742 6.00766 2.50492 5.79016L4.42492 3.87016C4.64242 3.65266 5.00242 3.65266 5.21992 3.87016C5.43742 4.08766 5.43742 4.44766 5.21992 4.66516L3.69742 6.18766L5.21992 7.71016C5.43742 7.92766 5.43742 8.28766 5.21992 8.50516C5.11492 8.61766 4.96492 8.67016 4.82242 8.67016Z"
    }
  )
] }), Xr = ({ toastInfo: r, callbackFunction: i, theme: a, texts: o, lang: l }) => {
  const [s, d] = A(!1), m = () => {
    d(!0);
    const p = i();
    if (p && !s) {
      const _ = jr();
      ae({ title: o.undoing, type: "promise", id: `toast-promise-${_}` }), p.then(() => {
        Ae(`toast-promise-${_}`), ae({ ...r, title: o.operationWasUndone, type: r.type ?? "success", callbackFunction: void 0, lang: l });
      }).catch(() => {
        Ae(`toast-promise-${_}`), ae({ ...r, title: o.errorInOperation, type: "error", callbackFunction: void 0, lang: l });
      });
    } else
      d(!1);
  };
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: `toast_undo ${a === "dark" ? "toast_undo-dark" : "toast_undo-light"}`,
      style: { cursor: s ? "default" : "pointer" },
      onClick: s ? () => {
      } : () => m(),
      children: [
        /* @__PURE__ */ c.jsx(Kr, { theme: a }),
        /* @__PURE__ */ c.jsx("span", { dir: "auto", children: o.undo })
      ]
    }
  );
}, Qr = ({ type: r, positionX: i, showToast: a, setShowToast: o, autoClose: l, theme: s, isHover: d }) => {
  const [m, p] = A(100), _ = oe(null), b = oe(d);
  F(() => {
    b.current = d;
  }, [d]), F(() => (a && p(100), l && a && (_.current = setInterval(() => {
    b.current || p((B) => B - 1e3 / l);
  }, 10)), () => clearInterval(_.current)), [a]);
  const E = () => {
    clearInterval(_.current), o(!1);
  };
  let w;
  F(() => (m <= 0 && E(), () => clearTimeout(w)), [m]);
  let S = "";
  return r === "success" ? S = s === "dark" ? "toast_progressBar-lime-dark" : "toast_progressBar-lime-light" : r === "warning" ? S = s === "dark" ? "toast_progressBar-orange-dark" : "toast_progressBar-orange-light" : r === "error" && (S = s === "dark" ? "toast_progressBar-red-dark" : "toast_progressBar-red-light"), /* @__PURE__ */ c.jsx("div", { className: "toast_progressBar", children: /* @__PURE__ */ c.jsx(
    "div",
    {
      style: { left: i === "left" ? 0 : "unset", right: i === "right" ? 0 : "unset", width: `${m}%` },
      className: `toast_progressBar-inner ${S}`
    }
  ) });
}, et = ({ className: r, onClick: i }) => /* @__PURE__ */ c.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { flex: "none" },
    className: r,
    onClick: i,
    children: /* @__PURE__ */ c.jsx("path", { d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" })
  }
), rt = ({ toastInfo: r, toastPosition: i, toasts: a, setToasts: o, texts: l, lang: s }) => {
  const [d, m] = A(!0), [p, _] = A(!1);
  F(() => {
    let E;
    return d === !1 && (E = setTimeout(() => m(void 0), 1e3)), () => clearTimeout(E);
  }, [d]);
  const b = Sr(d, i.left);
  return /* @__PURE__ */ c.jsx(c.Fragment, { children: d !== void 0 && /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: `toast ${s === "en" && "toast-ltr"} ${r.theme === "dark" ? "toast_dark" : "toast_light"} animate__animated ${b}`,
      style: { boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" },
      id: r.id,
      onMouseOver: () => _(!0),
      onMouseOut: () => _(!1),
      children: [
        /* @__PURE__ */ c.jsx(zr, { type: r.type, theme: r.theme }),
        /* @__PURE__ */ c.jsx("p", { dir: "auto", className: `toast_title ${s === "en" ? "toast_title_ltr" : "toast_title_rtl"}`, children: r.title }),
        r.type !== "promise" && r.callbackFunction && /* @__PURE__ */ c.jsx(
          Xr,
          {
            toastInfo: r,
            callbackFunction: r.callbackFunction,
            theme: r.theme,
            toasts: a,
            setToasts: o,
            texts: l,
            lang: s
          }
        ),
        r.type !== "promise" && r.autoClose && /* @__PURE__ */ c.jsx(
          Qr,
          {
            type: r.type,
            positionX: i.left !== "unset" ? "left" : "right",
            showToast: d,
            setShowToast: m,
            autoClose: r.autoClose,
            theme: r.theme,
            isHover: p
          }
        ),
        r.type !== "promise" && /* @__PURE__ */ c.jsx(
          et,
          {
            className: `toast_closeIcon ${r.theme === "dark" ? "toast_closeIcon-dark" : "toast_closeIcon-light"}`,
            onClick: () => m(!1)
          }
        )
      ]
    }
  ) });
}, nt = (r) => {
  const [i, a] = A([]), [o, l] = A(ie(r.lang ? r.lang : "fa")), s = oe({ position: "bottom-right", theme: "light", autoClose: 5e3, lang: r.lang ? r.lang : "fa" });
  F(() => (W.addListener("toast", (m) => {
    const p = ne(m);
    let _ = {};
    const b = { ...s.current, ...p, id: m.id ? `mobin-toast-${m.id}` : void 0 };
    _ = ie(b.lang), l(_), a((E) => [...E, b]);
  }), W.addListener("closeToast", (m) => {
    a((p) => p.filter((b) => b.id !== `mobin-toast-${m}`));
  }), () => W.removeAllListeners()), []), F(() => {
    s.current = { ...s.current, ...ne(r) };
  }, [r.theme]), F(() => {
    s.current = { ...s.current, ...ne(r) }, l(ie(r.lang ? r.lang : "fa"));
  }, [r.lang]);
  const d = wr(s.current.position);
  return /* @__PURE__ */ c.jsx(c.Fragment, { children: i.length ? /* @__PURE__ */ c.jsx("div", { className: "toast-wrapper", style: { ...d }, children: i.map((m) => /* @__PURE__ */ c.jsx(rt, { lang: r.lang, toastInfo: m, toastPosition: d, toasts: i, setToasts: a, texts: o }, m.id)) }) : /* @__PURE__ */ c.jsx(c.Fragment, {}) });
}, ae = ({ id: r, title: i, type: a, position: o, theme: l, autoClose: s, callbackFunction: d, lang: m }) => {
  W.emit("toast", { id: r, title: i, type: a, position: o, theme: l, autoClose: s, callbackFunction: d, lang: m });
}, Ae = (r) => W.emit("closeToast", r);
export {
  Ae as closeToast,
  nt as default,
  ae as toast
};
